<template>
  <div class="text-center">
    <v-dialog persistent v-model="dialog" width="500">
      <v-card>
        <ModelTitle title="Select Date" @close="setDateSelector(false)" />

        <v-container grid-list-lg>
          <DateTimePicker
            defaultRange="thisMonth"
            :range="true"
            :hideTime="true"
            v-model="dateTime"
          />
        </v-container>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="createReport()">
            Create Report
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
const DateTimePicker = () => import("@/components/DateTimePicker");
import { mapGetters, mapActions } from "vuex";

export default {
  props: ["CustomerId"],
  data() {
    return {
      dialog: false,
      dateTime: {
        start: null,
        end: null,
      },
    };
  },
  watch: {
    dateSelector(val) {
      this.dialog = val;
    },
    dialog(val) {
      if (val) {
        // Only set initial values when opening
        this.dateTime = {
          start:
            this.value?.start || this.$moment().startOf("month").toISOString(),
          end: this.value?.end || this.$moment().endOf("month").toISOString(),
        };
      }
    },
  },
  computed: {
    ...mapGetters("reportView", ["getDateSelector"]),
    dateSelector: {
      get: function () {
        return this.getDateSelector;
      },
      set: function (val) {
        this.setDateSelector(val);
      },
    },
  },
  components: {
    DateTimePicker,
  },
  methods: {
    ...mapActions("reportView", ["setDateSelector"]),
    createReport() {
      this.$emit("submit", this.dateTime);
      // this.$emit("submit", {
      //   start: this.dateTime.start,
      //   end: this.dateTime.end,
      // });
      this.setDateSelector(false);
    },
  },
};
</script>

<style scoped></style>
